import { jsx as _jsx } from "react/jsx-runtime";
// const minHeight = 550;
// const maxHeight = 800;
// const rowHeight = 52;
function DataInterchangeTabView({ children }) {
    return _jsx("div", { style: { width: '100%' }, children: children });
}
export default DataInterchangeTabView;
